let userCountryCode = null;
let userRegionCode = null;

const euroCodes = [
	'AX',
	'AL',
	'AD',
	'AM',
	'AT',
	'BY',
	'BE',
	'BA',
	'BG',
	'HR',
	'CY',
	'CZ',
	'DK',
	'EE',
	'FO',
	'FI',
	'FR',
	'GE',
	'DE',
	'GI',
	'GR',
	'GL',
	'GP',
	'GG',
	'VA',
	'HU',
	'IS',
	'IE',
	'IM',
	'IT',
	'JE',
	'XK',
	'LV',
	'LI',
	'LT',
	'LU',
	'MT',
	'YT',
	'MD',
	'MC',
	'ME',
	'NL',
	'MK',
	'NO',
	'PL',
	'PT',
	'RE',
	'RO',
	'SM',
	'RS',
	'SK',
	'SI',
	'ES',
	'SJ',
	'SE',
	'CH',
	'TR',
	'UA'
];
const americaCodes = [
	'AI',
	'AG',
	'AR',
	'AW',
	'BS',
	'BB',
	'BZ',
	'BM',
	'BO',
	'BR',
	'CA',
	'BQ',
	'KY',
	'CL',
	'CO',
	'CR',
	'DM',
	'DO',
	'EC',
	'SV',
	'FK',
	'GF',
	'TF',
	'GD',
	'GT',
	'GY',
	'HT',
	'HN',
	'JM',
	'MQ',
	'MX',
	'MS',
	'NI',
	'PA',
	'PY',
	'PE',
	'BL',
	'KN',
	'LC',
	'MF',
	'PM',
	'SX',
	'GS',
	'VC',
	'SR',
	'TT',
	'TC',
	'US',
	'UM',
	'UY',
	'VE',
	'VG',
];


function hideProducts() {
	fetch('/browsing_context_suggestions.json')
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			userCountryCode = data.detected_values.country.handle;

			userCountryCode && fetch('https://pro.ip-api.com/json?key=uJCNLVRxhMcYTzv', {
				method: 'GET',
				headers: {
					'Content-type': 'application/json; charset=UTF-8'
				}
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					userRegionCode = data && data.regionName;

					if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
						$('.product-col__wrapper .product-item').each(function () {
							const countryCodes = $(this).attr('data-country-code') && $(this).attr('data-country-code').split(',');
							const regionCodes = $(this).attr('data-region-code') && $(this).attr('data-region-code').split(',');

							if (regionCodes && regionCodes.includes(userRegionCode) ||
								countryCodes && countryCodes.includes(userCountryCode) ||
								(countryCodes.includes('EU') && euroCodes.includes(userCountryCode)) ||
								(countryCodes.includes('US') && americaCodes.includes(userCountryCode))) {
								$(this).addClass('product-item--not-available');
							}
						});
					}


					if ($('body').hasClass('template-index')) {
						$('.js-home-product').each(function () {
							const countryCodes = $(this).attr('data-country-code') && $(this).attr('data-country-code').split(',');
							const regionCodes = $(this).attr('data-region-code') && $(this).attr('data-region-code').split(',');

							if (regionCodes && regionCodes.includes(userRegionCode) ||
								countryCodes && countryCodes.includes(userCountryCode) ||
								(countryCodes.includes('EU') && euroCodes.includes(userCountryCode)) ||
								(countryCodes.includes('US') && americaCodes.includes(userCountryCode))) {
								$(this).addClass('home-product-hide');
							}
						});
					}


					if ($('body').hasClass('template-product')) {
						const countryCodes = $('.main-product-section').attr('data-country-code') && $('.main-product-section').attr('data-country-code').split(',');
						const regionCodes = $('.main-product-section').attr('data-region-code') && $('.main-product-section').attr('data-region-code').split(',');
						if (regionCodes && regionCodes.includes(userRegionCode) ||
							countryCodes && countryCodes.includes(userCountryCode) ||
							(countryCodes.includes('EU') && euroCodes.includes(userCountryCode)) ||
							(countryCodes.includes('US') && americaCodes.includes(userCountryCode))) {
							$('.template-product').addClass('template-product--not-available');
						}
						$('.recomend .recomend-container .product__item').length > 0 &&
						$('.recomend .recomend-container .product__item').each(function () {
							const countryCodes = $(this).attr('data-country-code') && $(this).attr('data-country-code').split(',');
							const regionCodes = $(this).attr('data-region-code') && $(this).attr('data-region-code').split(',');

							if (regionCodes && regionCodes.includes(userRegionCode) ||
								countryCodes && countryCodes.includes(userCountryCode) ||
								(countryCodes.includes('EU') && euroCodes.includes(userCountryCode)) ||
								(countryCodes.includes('US') && americaCodes.includes(userCountryCode))) {
								$(this).addClass('product__item--not-available');
							}
						});
					}
				});
		});
}

document.addEventListener("DOMContentLoaded", function () {
	hideProducts();
});

window.addEventListener('load', function() {
	heroBgHeight = $('#shopify-section-header .header').outerHeight();

	$('.js-split-switcher').on('click', function (e) {
		let activeId = $(this).attr('id');

		if (activeId === 'split-select__group') {
			$('.product-col__wrapper').removeClass('split-by-single');
		} else if (activeId === 'split-select__single') {
			$('.product-col__wrapper').addClass('split-by-single');
		}
	});

	$('.js-bundle-toggle').on('click', function (e) {
		e.stopPropagation();

		if ($(this).find('.bundle-toggle__checkbox').is(':checked')) {
			$('.product-col__wrapper').addClass('use-bundled-products');
		} else {
			$('.product-col__wrapper').removeClass('use-bundled-products');
		}
	});

	$('.js-description-poptitle-qr').on('click', function (e) {
		e.preventDefault();
		$('body').addClass('overlay');
		$('.js-qr-modal').addClass('qr-modal--visible');
		$('.js-qr-modal-container').addClass('qr-modal-container--visible');
	});

	$('.js-qr-modal-container, .js-qr-modal__close').on('click', function () {
		$('.js-qr-modal').removeClass('qr-modal--visible');
		$('.js-qr-modal-container').removeClass('qr-modal-container--visible');
		$('body').removeClass('overlay');
	})

	$('.login-popup .login-close').on('click', function () {
		$('.login-popup .tabs .login-tab').click();
	});


	$('.account--make').on('click', function () {
		$('.login-popup .tabs .register-tab').click();
	});

	$('.account--forgot').on('click', function () {
		$('.login-popup .sign-forgot').trigger('click');
	});

	$('.template-index .main .main__wrapper').addClass('in-view');


	if ($('.packages-buy__add').length > 0) {
		$('.packages-buy__add').attr('data-cart-add', $('.packages-select__selected').attr("data-id"));
	}

	$('.js-packages-buy').on('click', function () {
		$('body').addClass('overlay');
		$('.ajax-cart').addClass('is-open');
		$('.product__cart').removeClass('product__cart_active');
	});

	$('.js-packages-select-list__item').on('click', function () {
		const id = $(this).attr('data-id');
		const url = $(this).attr('data-url');
		const price = $(this).attr('data-price');
		const text = $(this).text();
		$('.packages-buy__add').attr("data-cart-add", id);
		$('.packages-buy__add .price').text(price);
		$('.packages-select__selected').text(text);
		$('.js-packages-select').removeClass('packages-select--active');
		setTimeout(function () {
			window.location.href = url;
		}, 0);
	});

	$(document).on('click', function (e) {
		const target = e.target;
		if ($('body').hasClass('template-product') && target.nodeName !== 'DIV') {
			$('.js-packages-select').removeClass('packages-select--active');
		}
	});

	$('.js-packages-select__view').on('click', function () {
		$('.js-packages-select').toggleClass('packages-select--active');
	});


	$('body').on('click', '.disclosure__close', function () {
		$('.disclosure__list').removeClass('disclosure__list--show');
		$('.disclosure__close').removeClass('disclosure__close--show');
	});



	$('.help-article-select--articles select').on('change', function () {
		window.location.href = $(this).val();
	});

	if ($('.help-article-select--articles select').length > 0) {
		$(`.help-article-select--articles select option[value='${window.location.pathname}']`).attr('selected', 'selected');
		$('.help-article-select--articles').addClass('help-article-select--loaded');
	}


	if ($('.help-article-select--category select').length > 0) {
		$('.help-article-select--category select option').each(function () {
			const handle = $(this).val().replaceAll(/\s/g,'').split('||')[0];
			$(this).attr('value', handle);
		});
		const currentCategory = $('.help-article-select--category').attr('data-category');
		$(`.help-article-select--category select option[data-category='${currentCategory}']`).attr('selected', 'selected');
		$('.help-article-select--category').addClass('help-article-select--loaded');
	}


	$('.help-article-select--category select').on('change', function () {
		window.location.href = $(this).val();
	});

	$('.help-center-categories__mobile-link').on('click', function (e) {
		e.preventDefault();
		window.location.href = $(this).siblings('.help-center-categories-item__info').find('ul a:first').attr('href');
	});

	$('.help-article-select--delivery select').on('change', function () {
		const index = $(this).val();
		$(`.help-article-delivery__item[data-delivery-index='${index}']`).siblings().removeClass('help-article-delivery__item--visible');
		$(`.help-article-delivery__item[data-delivery-index='${index}']`).addClass('help-article-delivery__item--visible');
	});


	$('.help-center-footer__top').on('click', function () {
		window.scrollTo(0, 0);
	});

	if ($('.help-article-sidebar__list').length > 0) {
		$(`.help-article-sidebar__link[href='${window.location.pathname}']`).addClass('help-article-sidebar__link--active');
	}

	if ($('.features-articles').length > 0) {
		$('.features-articles-item').each(function (i) {
			$(this).find('.features-articles-item__index').text(i + 1);
		});
	}

	if ($('.help-center-categories').length > 0) {
		$('.help-center-categories-item__info').each(function () {
			let count = $(this).find('ul li').length;
			$(this).find('.help-center-categories-item__see-all a:first-child span').text(count);
		});
	}


	$('.help-article .search-form, .help-center-hero .search-form, .section--blog-page .search-form').on('submit', function (e) {
		e.preventDefault();
	});

	$('.help-article .search-form, .help-center-hero .search-form, .section--blog-page .search-form').on('keyup keypress', function(e) {
		const keyCode = e.keyCode || e.which;
		if (keyCode === 13) {
			e.preventDefault();
			return false;
		}
	});

	if ($('.filter-blocks .filter-button').length > 0) {
		$('.filter-blocks .filter-button').each(function () {
			if (window.location.search.includes($(this).attr('data-url'))) {
				$('.filter-blocks .filter-button').removeClass('active');
				$(this).addClass('active');
			}
		});

		if (!window.location.search) {
			$('.filter-blocks .filter-button').eq(0).addClass('active');
		}
		if ($('.blog-list-item').length > 0) {
			$('.blog-list-item').each(function () {
				const tags = $(this).attr('data-tags').split(',').map(item => item.replaceAll(' ', '-'));
				const param = window.location.search.replace('?tags=', '');

				if (tags.includes(param)) {
					$(this).addClass('blog-list-item--visible');
				} else {
					$(this).removeClass('blog-list-item--visible');
				}

				if (!window.location.search || param === 'home') {
					$('.blog-list-item').addClass('blog-list-item--visible');
				}
			});
		}
	}

	if (window.location.href.includes('?account')) {
		$('.login-popup').addClass('is-open');
	}

	$('.js-load-more').on('click', function () {
		hideProducts();
	});

	if ($('.collection-banner')) {
		$('.collection-banner').css('height', heroBgHeight);
	}

	$('body').on('click', '.add-to-bag--quick', function () {
		document.body.classList.add('overlay');
		document.querySelector('.ajax-cart').classList.add('is-open');
	});




	$('.banner__switch-video').on('click', function () {
		document.querySelector('.banner__bg-video video').play();
		document.querySelectorAll('.banner__bg-video video').forEach(el=>el.click());
	});

	if ($('.banner__switch-video')) {
		$('.banner__switch-video').click();
	}

	if ($('.static-desktop--two .static__item-img video').length > 0) {
		document.querySelector('.static-desktop--two .static__item-img video').play();
	}


	$('.variants-popup .header-popup .variants.close, .ajax-cart .cart-header .close-cart').on('click', function () {
		$('.variants-overlay').click();
	})

	if ($('body').hasClass('template-product')) {
		$('.sticky__item--buy').addClass('sticky__item--buy--show');
		$('.variants-popup .content__variants .variants__inner .select-selected').length > 0 &&
		$('.variants-popup .content__variants .variants__inner .select-selected').each(function () {
			$(this).text($(this).prev('select').val());
		});
	}

	const htmlElement = document.querySelector('html');
	const scrollContainer = document.getElementById('scroll-container');

	$('.sufix-about-us .video-popup__wrapper .btn-close').on('click', function () {
		let src = $('.sufix-about-us .video-popup__wrapper .img-wrapper iframe').attr('src');

		setTimeout(function () {
			$('.sufix-about-us .video-popup__wrapper .img-wrapper iframe').attr('src', src);
		}, 0);
	});


	$('.js-custom-video-close').on("click",function(e){
		$('.exit-ambassador').length !== 0 && $('.exit-ambassador').click();
		$('.custom-video-iframe--ambs').length !== 0 && $('.custom-video-iframe--ambs iframe').pause();
	});

	$('.exit-ambassador').on("click",function(e){
		scrollContainer.classList.remove('no-tranform');
		htmlElement.classList.remove('is-locked');
	});


	$('.footer__wrapper .shop-now.btn').on("click",function(e){
		e.preventDefault();
		$(this).hide();
		$('.footer__wrapper .klaviyo-form').addClass('klaviyo-form--opened');
	});

	$('.js-video-btn').on("click",function(e){
		let iframeVideo = $(this).attr('data-video-link-iframe');

		if (iframeVideo) {
			$('.custom-video-iframe iframe').attr('src', iframeVideo.replace('/watch?v=', '/embed/'));
			scrollContainer.classList.add('no-tranform');
			htmlElement.classList.add('is-locked');
			document.querySelector('.custom-video-wrapper').classList.add('custom-video-wrapper--show');
		}
	});


	$('.js-video-btn-mobile').on("click",function(e){
		scrollContainer.classList.add('no-tranform');
		htmlElement.classList.add('is-locked');

		const iframeVideo = this.getAttribute('data-video-link-iframe').replace('/watch?v=', '/embed/');

		document.querySelector('.custom-video-iframe iframe').setAttribute('src', iframeVideo);
		setTimeout(function () {
			document.querySelector('.custom-video-wrapper').classList.add('custom-video-wrapper--show');
		}, 0);
	});


	$('.custom-video-exit').on("click",function(e){
		document.querySelector('.custom-video-wrapper').classList.remove('custom-video-wrapper--show');
		document.querySelector('.custom-video-iframe iframe').setAttribute('src', '');

		scrollContainer.classList.remove('no-tranform');
		htmlElement.classList.remove('is-locked');

	});

	document.querySelector('.custom-video-overlay').addEventListener("click",function(e){
		document.querySelector('.custom-video-wrapper').classList.remove('custom-video-wrapper--show');
		document.querySelector('.custom-video-iframe iframe').setAttribute('src', '');
		scrollContainer.classList.remove('no-tranform');
		htmlElement.classList.remove('is-locked');
	},false)


	$('.search-form').on('submit', function (e) {
		e.preventDefault();
		if ($('.search-form .search-results__all a').length > 0) {
			window.location.href = window.location.origin + $('.search-form .search-results__all a').attr('href');
		}
	});

});

$(window).scroll(function () {

	if($(window).scrollTop() >= 130) {
		$('body').addClass('start-scrolling');
	} else if ($(window).scrollTop() <= 75) {
		$('body').removeClass('start-scrolling');
	}

	if ($('.our-stores-banner .anchors').length > 0) {
		heroBgHeight = $('#shopify-section-header .header').outerHeight();
		const anchors = $('.our-stores-banner .anchors');
		const elemPos = $('.anchors-position').offset().top - heroBgHeight;

		if ($(this).scrollTop() >= elemPos) {
			anchors.css('top', heroBgHeight);
			$('.our-stores-banner .anchors__wrapper-item.first_item').addClass('hide');
			anchors.addClass('anchor--custom-fixed');
		} else {
			anchors.css('top', 'initial');
			$('.our-stores-banner .anchors__wrapper-item.first_item').removeClass('hide');
			anchors.removeClass('anchor--custom-fixed');
		}
	}

	if ($(window).scrollTop() > $(window).height()) {
		$('.js-progress-scroll').addClass('backtotop--show');
	} else {
		$('.js-progress-scroll').removeClass('backtotop--show');
	}
});

$('#shopify-section-header').on('DOMNodeInserted', function(e) {
	if ($('#fsb_container').length > 0 && !$('html').hasClass('is-bar')) {
		$('html').addClass('is-bar');
		$('.filter') && $('.filter').addClass('filter--with-bar');
	}
});


class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('.custom-currency input[name="language_code"], .custom-currency input[name="country_code"]'),
			button: this.querySelector('.custom-currency button'),
			panel: this.querySelector('.custom-currency ul'),
			parent: this.querySelector('.disclosure'),
		};
		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.parent.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('.disclosure__item a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('.custom-currency form');
		this.elements.input.value = event.currentTarget.dataset.value;
		const currentValue = this.elements.input.value.toLowerCase();
		if (form) form.submit();
		// $('.custom-lang-selector .ly-custom-dropdown-list > li').each(function () {
		// 	if ($(this).attr('key') === currentValue) {
		// 		$(this).find('span').click();
		// 		console.log($(this).attr('key'), currentValue);
		// 	}
		// });
	}

	openSelector() {
		if ($(window).width() < 991) {
			this.elements.panel.classList.add('disclosure__list--show');
			this.elements.parent.classList.add('disclosure--active');
			$('.disclosure__close').addClass('disclosure__close--show');
		}
	}

	closeSelector(event) {
		if ($(window).width() < 991) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.elements.panel.classList.remove('disclosure__list--show');
				this.elements.parent.classList.remove('disclosure--active');
				$('.disclosure__close').removeClass('disclosure__close--show');
			}
		}
	}
}

customElements.define('localization-form', LocalizationForm);

